var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconnegocio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 27,
    fill: "none",
    viewBox: "0 0 29 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M24.076 2.832H4.249A4.248 4.248 0 0 0 0 7.081v7.08a4.248 4.248 0 0 0 4.249 4.25h19.827a4.248 4.248 0 0 0 4.249-4.25v-7.08a4.248 4.248 0 0 0-4.25-4.249Z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M14.162 14.87a2.124 2.124 0 1 0 0-4.248 2.124 2.124 0 0 0 0 4.249Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M24.076 18.41H4.249A4.248 4.248 0 0 1 0 14.163v8.498a4.248 4.248 0 0 0 4.249 4.248h19.827a4.248 4.248 0 0 0 4.249-4.248v-8.498a4.248 4.248 0 0 1-4.25 4.249ZM15.579 0h-2.833a2.832 2.832 0 0 0-2.832 2.832h8.497A2.832 2.832 0 0 0 15.578 0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconnegocio);
export default __webpack_public_path__ + "static/media/icon negocio.b791b113eb69606c729f41e4c1fb6a98.svg";
export { ForwardRef as ReactComponent };